"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimingToolSearchStore = exports.DEFAULT_CLAIM_CRITERIA = exports.DEFAULT_CLAIM_PAGINATION = void 0;
const get_search_query_1 = require("@App/helpers/get-search-query");
const mobx_1 = require("mobx");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const find_page_on_limit_change_1 = require("@App/helpers/pagination/find-page-on-limit-change");
const search_1 = require("@App/api/routes/search");
const generate_search_criterion_1 = require("@App/helpers/generate-search-criterion");
const work_1 = require("@App/api/routes/work");
exports.DEFAULT_CLAIM_PAGINATION = {
    page: 1,
    limit: 10,
};
exports.DEFAULT_CLAIM_CRITERIA = [
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(get_search_query_1.SEARCH_WORK_OPTIONS[0], true),
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(get_search_query_1.SEARCH_WORK_OPTIONS[1], true),
];
class ClaimingToolSearchCriteriaStore extends search_criteria_store_1.default {
    constructor(criteria, options, optionType, requiredCriteria, maxCriteria, rightsholderStore) {
        super(criteria, options, optionType, requiredCriteria, maxCriteria);
        Object.defineProperty(this, "rightsholderStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.rightsholderStore = rightsholderStore;
    }
    searchAutoCompleteSuggestions(property, searchTerm) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const cleanSearch = encodeURIComponent(searchTerm).toLowerCase();
            const suggestions = yield (0, work_1.searchSuggestions)(property, cleanSearch, (_a = this.rightsholderStore.currentRightsholder) === null || _a === void 0 ? void 0 : _a.hfaPublisherNumber, true);
            (0, mobx_1.runInAction)(() => (this._autoCompleteSuggestions = suggestions.data));
        });
    }
}
class ClaimingToolSearchStore {
    createClaimingToolSearchCriteriaStore() {
        const maxCriteria = 5;
        return new ClaimingToolSearchCriteriaStore(exports.DEFAULT_CLAIM_CRITERIA, get_search_query_1.SEARCH_WORK_OPTIONS, search_option_type_1.SearchOptionType.filter, required_criteria_1.RequiredCriteria.some, maxCriteria, this.rootStore.rightsholderStore);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_unclaimedWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_claimingToolSearchCriteriaStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_unclaimedWorksPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_claimFilter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_claimPaginationBody", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_claimSearchQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_redirectingToCatalog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "getUnclaimedWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const works = yield this.getUnclaimedWorksApiCall();
                    this.processUnclaimedAndLoadShares(works, this._claimPaginationBody);
                }
                catch (e) {
                    this.rootStore.popupStore.setAlertFromError(e);
                }
            })
        });
        Object.defineProperty(this, "getUnclaimedWorksApiCall", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                try {
                    if (this._claimSearchQuery) {
                        const search = Object.assign(Object.assign(Object.assign({}, this._claimSearchQuery), { isOverclaimable: true }), (((_a = this._claimFilter) === null || _a === void 0 ? void 0 : _a.notClaimedBy) && { notClaimedBy: (_b = this._claimFilter) === null || _b === void 0 ? void 0 : _b.notClaimedBy }));
                        const apiResponse = yield (0, search_1.searchWorks)(this._claimPaginationBody, search);
                        return { count: apiResponse.data.totalElements, works: apiResponse.data.content };
                    }
                    else {
                        this.rootStore.popupStore.setAlertData('Unable to read claim query', true);
                        return undefined;
                    }
                }
                catch (e) {
                    this.rootStore.popupStore.setAlertFromError(e);
                    return undefined;
                }
            })
        });
        (0, mobx_1.makeObservable)(this, {
            _claimFilter: mobx_1.observable,
            setClaimFilter: mobx_1.action,
            setRedirectingToCatalog: mobx_1.action,
            claimSearchQuery: mobx_1.computed,
            _unclaimedWorks: mobx_1.observable,
            _unclaimedWorksPaginationInfo: mobx_1.observable,
            destroyUnclaimedWorks: mobx_1.action,
            destroyUnclaimedWorksPaginationInfo: mobx_1.action,
            processUnclaimedAndLoadShares: mobx_1.action,
        });
        this.rootStore = rootStore;
        this.resetClaimSearchCriteriaIfNeeded();
    }
    setCurrentPage(page) {
        this._claimPaginationBody.page = page;
    }
    get limit() {
        var _a;
        return (_a = this._claimPaginationBody.limit) !== null && _a !== void 0 ? _a : exports.DEFAULT_CLAIM_PAGINATION.limit;
    }
    onChangeLimit(newLimit) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._unclaimedWorks) {
                const pagination = {
                    page: this._claimPaginationBody.page,
                    limit: this._claimPaginationBody.limit,
                };
                const newPage = (0, find_page_on_limit_change_1.findPageOnLimitChange)(pagination, this._unclaimedWorks.count, newLimit, 1);
                this.setCurrentPage(newPage);
            }
            this._claimPaginationBody.limit = newLimit;
            yield this.getUnclaimedWorks();
        });
    }
    get searchCriteriaStore() {
        return this._claimingToolSearchCriteriaStore;
    }
    resetSearchCriteriaStore() {
        this._claimingToolSearchCriteriaStore = this.createClaimingToolSearchCriteriaStore();
    }
    resetClaimSearchCriteriaIfNeeded() {
        if (!this.redirectingToCatalog) {
            this._claimSearchQuery = undefined;
            this.resetSearchCriteriaStore();
            this.destroyUnclaimedWorks();
            this.destroyUnclaimedWorksPaginationInfo();
            this.resetClaimSearchQuery();
            this._claimPaginationBody = exports.DEFAULT_CLAIM_PAGINATION;
        }
        this.setRedirectingToCatalog(false);
    }
    get redirectingToCatalog() {
        return this._redirectingToCatalog;
    }
    setRedirectingToCatalog(value) {
        this._redirectingToCatalog = value;
    }
    setClaimFilter(filter) {
        this._claimFilter = filter;
    }
    setClaimPaginationBody(pagination) {
        this._claimPaginationBody = pagination;
    }
    get claimSearchQuery() {
        return this._claimSearchQuery;
    }
    setClaimSearchQuery(claimSearchQuery) {
        this._claimSearchQuery = claimSearchQuery;
    }
    resetClaimSearchQuery() {
        this._claimSearchQuery = undefined;
    }
    processUnclaimedAndLoadShares(response, pagination) {
        if (response) {
            this._unclaimedWorks = response;
            if (pagination.limit && pagination.page && response) {
                this._unclaimedWorksPaginationInfo = (0, calc_num_pages_1.calcNumPages)(response.count, pagination.limit, pagination.page, pagination.refined);
            }
            if (this._unclaimedWorks) {
                const workIds = this._unclaimedWorks.works
                    .map((work) => work.id)
                    .filter((workId) => !!workId);
                this.rootStore.rightsholderStore.loadClaimedShares(workIds).then();
            }
        }
    }
    get unclaimedWorks() {
        return this._unclaimedWorks;
    }
    destroyUnclaimedWorks() {
        this._unclaimedWorks = undefined;
    }
    get unclaimedWorksPaginationInfo() {
        return this._unclaimedWorksPaginationInfo;
    }
    destroyUnclaimedWorksPaginationInfo() {
        this._unclaimedWorksPaginationInfo = undefined;
    }
}
exports.ClaimingToolSearchStore = ClaimingToolSearchStore;
